import { Study } from '@mitsubishi/shared/data-access';

import { Selector } from '@ngxs/store';

import { Project, ProjectDetails, Selection } from '../../models';
import { EnergyAnalysis } from '../../models/energy-analysis.model';
import { canUpdateProjectCertificationOrUnitMeasures } from '../../utils/project-certification.utils';
import { PROJECT_STATE_TOKEN, ProjectStateModel } from './project.model';

export class ProjectSelectors {
  @Selector([PROJECT_STATE_TOKEN])
  static current(state: ProjectStateModel) {
    return state?.current;
  }

  @Selector([ProjectSelectors.current])
  static projectDetails(state: Project) {
    return state?.details;
  }

  @Selector([ProjectSelectors.current])
  static projectSelections(details: Project): Selection[] {
    return Object.values(details?.selections ?? {});
  }

  @Selector([ProjectSelectors.current])
  static projectDocuments(details: Project) {
    return Object.values(details?.documents ?? {});
  }

  @Selector([ProjectSelectors.projectDetails])
  static projectId(details: ProjectDetails) {
    return details?.uuid;
  }

  @Selector([ProjectSelectors.projectDetails])
  static projectCode(details: ProjectDetails) {
    return details?.code;
  }

  @Selector([ProjectSelectors.current])
  static projectCompanies(details: Project) {
    return Object.values(details?.companies ?? {});
  }

  @Selector([ProjectSelectors.current])
  static projectStudies(details: Project): Study[] {
    if (!details || !details.studies) {
      return [];
    }

    return Object.values(details.studies);
  }

  @Selector([ProjectSelectors.current])
  static projectEnergyAnalysis(details: Project): EnergyAnalysis[] {
    return Object.values(details?.energyAnalysis ?? {});
  }

  @Selector([ProjectSelectors.projectDetails])
  static projectOrganizationId(details: ProjectDetails) {
    return details.organizationId;
  }

  @Selector([ProjectSelectors.current])
  static canUpdateProjectCertificationOrUnitMeasures(project: Project) {
    return canUpdateProjectCertificationOrUnitMeasures(project);
  }

  @Selector([ProjectSelectors.current])
  static projectCertification(project: Project) {
    return project.details.certification;
  }

  @Selector([ProjectSelectors.current])
  static projectFeature(project: Project) {
    return project.details.elcaFeature;
  }
}
